import {useGetAndSet} from "./useGetAndSet";
import {createSetNominalCodesDataAction} from "../actions/dataActions";

export const useNominalCodesData = (params, dataFresh) => {
    return useGetAndSet("nominal", params, createSetNominalCodesDataAction, dataFresh);
}